// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"30a2b515","769":"624d84ac"}[chunkId] + ".chunk.js";
};